import { animate, animateChild, AnimationTriggerMetadata, group, query, stagger, state, style, transition, trigger } from "@angular/animations";

export const heightAnimation: AnimationTriggerMetadata = trigger('grow', [
	transition('void <=> *', []),
	transition('* <=> *', [
		group([
			style({height: '{{startHeight}}px'}),
			animate('250ms cubic-bezier(.4, 0, .2, 1)'),
			query(':enter', [
				style({opacity: 0}),
				animate('250ms cubic-bezier(.4, 0, .2, 1)', style({opacity: 1}))
			], {optional: true})
		])
	], {params: {startHeight: 0}})
]);

export const iconExpandAnimation: AnimationTriggerMetadata = trigger('iconExpanded', [
	state('false', style({transform: 'rotate(0deg)'})),
	state('true', style({transform: 'rotate(-180deg)'})),
	transition('* => *', animate('225ms cubic-bezier(.4, 0, .2, 1)'))
]);

export const overlayPanelAnimation: AnimationTriggerMetadata = trigger('panel', [
    state('void', style({transform: 'scale(.8)', opacity: 0})),
    state('show', style({opacity: 1, transform: 'scale(1)'})),
    transition('void => *', animate('120ms cubic-bezier(0, 0, .2, 1)')),
    transition('* => void', animate('100ms 25ms linear', style({opacity: 0}))),
]);

export const baseAnimation: AnimationTriggerMetadata[] = [
	trigger('animated', [
		transition(':enter', [
			style({transform: 'scale(.75)', 'transform-origin': 'center', opacity: 0, width: 0, 'padding-left': 0, 'padding-right': 0}),
			animate('250ms cubic-bezier(0, 0, .2, 1)', 
				style({transform: 'scale(1)', opacity: 1,  width: '*', 'padding-left': '*', 'padding-right': '*'})
			)
		]),
		transition(':leave', [
			style({ transform: 'scale(1)', 'transform-origin': 'center', opacity: 1, width: '*', 'padding-left': '*', 'padding-right': '*'}),
			animate('150ms cubic-bezier(.4, 0, .2, 1)', 
				style({transform: 'scale(.5)', opacity: 0, width: 0, 'padding-left': 0, 'padding-right': 0})
			) 
		])
	]),

	trigger('animatedEnter', [
		transition(':enter', [
			style({opacity: 0, transform: 'scale(.75)', 'transform-origin': 'center'}),
			animate('250ms cubic-bezier(0, 0, .2, 1)', style({opacity: 1, transform: 'scale(1)'}))
		])
	]),

	trigger('animatedSet', [
		transition('* <=> *', [
			query('@animated, @animatedEnter', stagger(100, animateChild()), {optional: true})
		])
	])
];